module.exports = __webpack_public_path__ + "img/sel_Dalian.46fa3c51.png";